module.exports = __webpack_public_path__ + "img/st-cb6-1-110.2930fd61.gif";